<script>
    import { sgettext } from '../../../i18n';

    import DropdownArrow from "./DropdownArrow.svelte";

    export let name;
    export let worksequences;
    export let roleIndex;


    let isExpanded = true;

    const toggleExpand = () => isExpanded = !isExpanded;

</script>

<table class="table">
  <thead class="thead-light" on:click={toggleExpand}>
    <tr>
      <th colspan="2">
        <div class="th-content">
          {sgettext('$$ROLE$$')} -
          {roleIndex + 1}
          {name}
          <DropdownArrow rotate={isExpanded ? 0 : 270} />
        </div>
      </th>
    </tr>
  </thead>
  {#if isExpanded}
    <slot />
  {/if}
</table>

<style>
  .thead-light th {
    position: relative;
    background: #ced4da;
  }

  .th-content {
    display: flex;
    align-items: center;
  }

  th {
    font-size: large;
  }
</style>
